import React from 'react';

import { useExportTemplate } from 'Templates';

import { TEMPLATE_PLAYERS_INFORMATION } from 'scenes/PlayersActivities/PlayersInformation/constants';

import DownloadTemplateForm from './DownloadTemplateForm';

const DownloadTemplate = (props) => {
  const [exportTemplate] = useExportTemplate({
    name: TEMPLATE_PLAYERS_INFORMATION,
  });

  const handleSubmit = async (values) => {
    await exportTemplate(values);
    props?.onClose();
  };

  return <DownloadTemplateForm {...props} onSubmit={handleSubmit} />;
};

export default DownloadTemplate;
